<template>
  <div>
    <section-header
      id="buyerpersonatags"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
      >Buyer persona tags</section-header
    >
    <v-btn v-if="addBpTag == false" @click="addBpTag = true" small>
      <v-icon>add</v-icon> Buyer persona tag
    </v-btn>
    <v-form ref="bptfForm" v-if="addBpTag == true">
      <div class="ajaxForm">
        <v-select
          label="Choose buyer persona tag"
          v-model="bptagid"
          :items="computedBpTags"
          item-value="id"
          item-text="name"
          :rules="valueRules"
          outline
        ></v-select>
        <v-btn @click="createBpTagFile"> <v-icon>save</v-icon> Save</v-btn>
        <v-btn @click="addBpTag = false"> Cancel </v-btn>
      </div>
    </v-form>
    <div v-if="!computedBpTagFilesPresent">No buyer persona tags</div>
    <v-data-table
      v-if="computedBpTagFilesPresent"
      :headers="headers"
      :items="bpTagFiles"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-chip outline :color="props.item.bptag.colour">{{
              props.item.bptag.name
            }}</v-chip>
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td><EntityZ :entity="props.item.user" format="system" /></td>
          <td>
            <v-btn @click="deleteBpTagFile(props.item.bptagid)" small
              >Delete</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
import SectionHeader from "@/components/file/SectionHeader";
export default {
  name: "BuyerPersonaTags",
  props: ["departmentId", "swiftMove"],
  components: {
    EntityZ,
    SectionHeader
  },
  computed: {
    computedBpTagFilesPresent() {
      return this.bpTagFiles && this.bpTagFiles.length;
    },
    computedBpTags() {
      if (!this.computedBpTagFilesPresent) {
        return this.bpTags;
      }
      return this.bpTags.filter((bpt) => {
        const bpTagFile = this.bpTagFiles.find(
          (bptf) => bptf.bptag.id == bpt.id
        );
        return bpTagFile == undefined ? true : false;
      });
    }
  },
  data() {
    return {
      bpTags: null,
      bpTagFiles: null,
      bptagid: null,
      addBpTag: false,
      headers: [
        {
          text: "Name",
          value: "bptag.name"
        },
        {
          text: "Date",
          value: "timestamp"
        },
        {
          text: "User",
          value: "user.name"
        },
        {
          text: " ",
          sortable: false
        }
      ],
      snackbar: false,
      snackbarText: null,
      valueRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchBpTags() {
      const response = await nbmlaw.get(`/cors/admin/file/bpTags`);
      // console.log(response.data)
      this.bpTags = response.data;
    },
    async fetchBpTagFiles() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/bpTagFiles`
      );
      //   console.log(response.data);
      this.bpTagFiles = response.data;
    },
    async createBpTagFile() {
      try {
        if (this.$refs.bptfForm.validate()) {
          await nbmlaw.post(
            `/cors/admin/file/files/${this.$route.params.id}/bpTagFiles`,
            null,
            {
              params: {
                bptagid: this.bptagid
              }
            }
          );
          // console.log(response.data);
          this.fetchBpTagFiles();
          this.addBpTag = false;
          this.bptagid = null;
        }
      } catch (err) {
        // console.log(err);
        this.snackbar = true;
        this.snackbarText = `There was an error`;
      }
    },
    async deleteBpTagFile(id) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/file/files/${this.$route.params.id}/bpTags/${id}`
        );
        this.fetchBpTagFiles();
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchBpTagFiles();
      }
    }
  },
  created() {
    this.fetchBpTags();
  }
};
</script>